import React, { Component } from 'react';
import { connect } from 'dva';
import { deepClone } from '@/utils/utils';
import { reportEvent } from '@/utils/report';
import { PRODUCT_TYPE_MAP, NAT_TYPE_MAP as INIT_NAT_TYPE_MAP } from '../../config/list';
import { Toast } from 'antd-mobile';
import styles from '../../styles/list.less';

const SORT_MAP = {
  '1': '默认排序',
  '2': '备注排序',
  '3': '昨日收益最高',
  '4': '昨日收益最低',
  '5': '总收益最高',
  '6': '总收益最低',
};

let GROUP_MAP = {};

const DEVICE_TYPE_MAP = deepClone(PRODUCT_TYPE_MAP);

//自定义筛选中，当前选中
export const FILTER_CUSTOM = {
  show: false,
  nat: [],
  disk: [],
  isp: [],
  province: [],
  selectedLength: 0,
};

const NAT_TYPE_MAP = deepClone(INIT_NAT_TYPE_MAP);
//删掉一个对称型
delete NAT_TYPE_MAP['5.1'];

const DISK_TYPE_MAP = {
  '1': '0-500G',
  '2': '500G-1T',
  '3': '1T-3T',
  '4': '3T以上',
};

const ISP_MAP = {
  电信: '电信',
  移动: '移动',
  联通: '联通',
};

const PROVINCE_MAP = {
  北京: '北京',
  上海: '上海',
  天津: '天津',
  重庆: '重庆',
  云南: '云南',
  吉林: '吉林',
  四川: '四川',
  安徽: '安徽',
  山东: '山东',
  山西: '山西',
  广东: '广东',
  江苏: '江苏',
  江西: '江西',
  河北: '河北',
  河南: '河南',
  浙江: '浙江',
  海南: '海南',
  湖北: '湖北',
  湖南: '湖南',
  甘肃: '甘肃',
  福建: '福建',
  贵州: '贵州',
  辽宁: '辽宁',
  陕西: '陕西',
  青海: '青海',
  黑龙江: '黑龙江',
  西藏: '西藏',
  广西: '广西',
  新疆: '新疆',
  宁夏: '宁夏',
  内蒙古: '内蒙古',
  香港: '香港',
  澳门: '澳门',
  台湾: '台湾',
};

const DEVICE_STATUS_MAP = {
  '-1': '全部',
  '1': '在线',
  '0': '离线',
  '2': '异常',
};

//默认排序
export const defaultSortKey = '1';
//全部
export const defaultGroupKey = '-1';
//全部
export const defaultDeviceTypeKey = '-1';
//全部
export const defaultDeviceStatusKey = '-1';

//存储自定义筛选框中的原始条件
let originCustionSelected = {};

export default
@connect(({ deviceList, user }) => ({ deviceList, user }), null, null, {
  withRef: true,
})
class HeaderSearch extends Component {
  constructor(props) {
    super(props);

    let customFilter = deepClone(FILTER_CUSTOM);
    this.state = {
      options: {
        sort: [],
        group: [],
        deviceType: [],
        deviceStatus: [],
        nat: [],
        disk: [],
        isp: [],
        province: [],
      },
      filter: {
        sort: {
          show: false,
          selected: defaultSortKey,
        },
        group: {
          show: false,
          selected: defaultGroupKey,
        },
        deviceType: {
          show: false,
          selected: defaultDeviceTypeKey,
        },
        custom: customFilter,
        deviceStatus: {
          selected: defaultDeviceStatusKey,
        },
      },
    };
  }

  componentDidMount() {
    let mySelf = this;
    mySelf.init();
  }

  init = () => {
    let mySelf = this;
    mySelf.initOptions();
    mySelf.assembleOptions();
    // 保留筛选状态
    const { filter } = mySelf.props.device;
    mySelf.setState({
      filter,
    });
  };

  initOptions = () => {
    let mySelf = this;
    let { options } = mySelf.state;
    let sortOptions = [];
    let deviceTypeOptions = [];
    let deviceStatusOptions = [];
    let natOptions = [];
    let diskOptions = [];
    let ispOptions = [];
    let provinceOptions = [];

    //排序
    for (let key in SORT_MAP) {
      let item = {
        key: key,
        label: SORT_MAP[key],
      };
      sortOptions.push(item);
    }

    //设备类型
    if (DEVICE_TYPE_MAP['-1'] === '类型') delete DEVICE_TYPE_MAP['-1'];
    for (let key in DEVICE_TYPE_MAP) {
      let item = {
        key: key,
        label: DEVICE_TYPE_MAP[key],
      };
      deviceTypeOptions.push(item);
    }
    deviceTypeOptions.unshift({ key: '-1', label: '全部' });
    // console.log('deviceTypeOptions', deviceTypeOptions);
    DEVICE_TYPE_MAP['-1'] = '类型';

    //状态
    // for (let key in DEVICE_STATUS_MAP){
    //   let item = {
    //     key: key,
    //     label: DEVICE_STATUS_MAP[key]
    //   };
    //   deviceStatusOptions.push(item);
    // };
    deviceStatusOptions.push({ key: '-1', label: '全部' });
    deviceStatusOptions.push({ key: '1', label: '在线' });
    deviceStatusOptions.push({ key: '0', label: '离线' });
    deviceStatusOptions.push({ key: '2', label: '异常' });

    //nat
    for (let key in NAT_TYPE_MAP) {
      let item = {
        key: key,
        label: NAT_TYPE_MAP[key],
      };
      natOptions.push(item);
    }

    //磁盘空间
    for (let key in DISK_TYPE_MAP) {
      let item = {
        key: key,
        label: DISK_TYPE_MAP[key],
      };
      diskOptions.push(item);
    }

    //运营商
    for (let key in ISP_MAP) {
      let item = {
        key: key,
        label: ISP_MAP[key],
      };
      ispOptions.push(item);
    }

    //省份
    for (let key in PROVINCE_MAP) {
      let item = {
        key: key,
        label: PROVINCE_MAP[key],
      };
      provinceOptions.push(item);
    }

    options.sort = sortOptions;
    options.deviceType = deviceTypeOptions;
    options.deviceStatus = deviceStatusOptions;
    options.nat = natOptions;
    options.disk = diskOptions;
    options.isp = ispOptions;
    options.province = provinceOptions;

    mySelf.setState({
      options,
    });
  };

  assembleOptions = () => {
    let mySelf = this;
    let { options } = mySelf.state;
    const {
      device: { groupList, originDeviceList, groupOptions: oldGroupOptions },
      dispatch,
      user: { refresh },
    } = mySelf.props;
    // 如果已经聚合果且不用主动刷新就不用重新聚合
    if (!refresh && oldGroupOptions && oldGroupOptions[0].key !== '-1') {
      options.group = oldGroupOptions;
    } else {
      let groupOptions = [];
      // console.log(groupList);
      // console.log(originDeviceList);

      //聚合出每组有多少台设备
      let map = {};
      originDeviceList.forEach(function(item) {
        let { gid } = item;
        if (map[gid]) {
          map[gid]++;
        } else {
          map[gid] = 1;
        }
      });
      // console.log(map);
      groupList.forEach(function(item) {
        let { gid, gname } = item;
        GROUP_MAP[gid] = gname;
        let count = map[gid] || 0;
        let unit = {
          key: gid,
          label: gname,
          count,
        };
        groupOptions.push(unit);
      });
      groupOptions.unshift({ key: '-1', label: '全部' });
      // console.log(groupOptions);

      GROUP_MAP['-1'] = '分组';
      options.group = groupOptions;

      // 保存聚合之后的状态
      dispatch({
        type: 'device/save',
        payload: {
          groupOptions,
        },
      });
      // console.log('groupOptions:', groupOptions);
    }
    mySelf.setState({
      options,
    });
  };

  //从url中解析携带过来的筛选参数
  initParsFromUrl = () => {
    let mySelf = this;
    // console.log(mySelf.props.location);
    let { deviceStatus, gid } = mySelf.props.urlQuery;
    // console.log(deviceStatus);
    // console.log(gid);
    let { filter } = mySelf.state;
    const {
      user: { refresh },
    } = mySelf.props;
    // 如果是返回列表页需要刷新状态，则不解析URL，保留筛选状态
    if (refresh) return;

    if (deviceStatus !== undefined) {
      filter.deviceStatus.selected = deviceStatus;
      // console.log('解析URL');
      mySelf.setState({
        filter,
      });
    }

    if (gid !== undefined) {
      filter.group.selected = gid;
      mySelf.setState({
        filter,
      });
    }
    mySelf.updateFilterOptions(filter);
  };

  showFilterModal = (filterType, pars = true) => {
    let mySelf = this;
    let { filter } = mySelf.state;
    filter[filterType].show = pars;
    mySelf.setState({
      filter,
    });
    mySelf.updateFilterOptions(filter);
  };

  closeAllFilterModal = () => {
    let mySelf = this;
    let { filter } = mySelf.state;
    filter.sort.show = false;
    filter.group.show = false;
    filter.deviceType.show = false;
    filter.custom.show = false;
    mySelf.setState({
      filter,
    });
    mySelf.updateFilterOptions(filter);
  };

  triggerCustomModal = (pars = true) => {
    let mySelf = this;
    // 自定义条件的弹窗 && 打开时 => 存储一下原始选项
    if (pars) {
      mySelf.saveCustomSelected();
    } else {
      mySelf.resetCustomSelected();
    }

    mySelf.showFilterModal('custom', pars);
  };

  saveCustomSelected = () => {
    let mySelf = this;
    let { filter } = mySelf.state;
    let { custom } = filter;
    originCustionSelected = deepClone(custom);
  };

  resetCustomSelected = () => {
    let mySelf = this;
    let { filter } = mySelf.state;
    filter.custom = originCustionSelected;
    mySelf.setState({
      filter,
    });
    mySelf.updateFilterOptions(filter);
  };

  //点击筛选条件
  clickFilter = filterType => {
    let mySelf = this;
    let {
      device: { listCanSelected },
    } = this.props;
    //编辑状态不可筛选
    if (listCanSelected) {
      Toast.info('编辑状态下，不可筛选！');
      return false;
    }

    let { filter } = mySelf.state;
    let showModal = filter[filterType].show;
    let toggle = !showModal;
    mySelf.closeAllFilterModal();
    if (filterType === 'custom') {
      mySelf.triggerCustomModal(toggle);
    } else {
      mySelf.showFilterModal(filterType, toggle);
    }
  };

  changeFilter = (filterType, key) => {
    let mySelf = this;
    let { filter } = mySelf.state;
    let {
      device: { listCanSelected },
    } = this.props;
    //编辑状态不可筛选
    if (listCanSelected) {
      Toast.info('编辑状态下，不可筛选！');
      return false;
    }
    filter[filterType].selected = key;
    mySelf.setState({
      filter,
    });
    mySelf.updateFilterOptions(filter);
    mySelf.showFilterModal(filterType, false);
    mySelf.props.triggerSearch(true);

    this.reportFilter();
  };

  //自定义筛选框
  changeCustomFilter = (filterType, key) => {
    let mySelf = this;
    let { filter } = mySelf.state;
    let { custom } = filter;
    let list = deepClone(custom[filterType]);
    // custom[filterType].push(key);

    if (list.includes(key)) {
      let index = list.indexOf(key);
      list.splice(index, 1);
      custom.selectedLength--;
    } else {
      list.push(key);
      custom.selectedLength++;
    }

    // console.log(custom);
    filter.custom[filterType] = list;
    mySelf.setState({
      filter,
    });
    mySelf.updateFilterOptions(filter);
  };

  completeCustomSelected = () => {
    let mySelf = this;
    // mySelf.saveCustomSelected();
    mySelf.showFilterModal('custom', false);
    mySelf.props.triggerSearch(true);
    this.reportFilter();
  };

  clearCustomFilter = () => {
    let mySelf = this;
    let { filter } = mySelf.state;
    // let custom = filter.custom.;
    if (filter.custom.selectedLength === 0) {
      return false;
    }

    let customFilter = deepClone(FILTER_CUSTOM);
    customFilter.show = true;
    customFilter.selectedLength = 0;
    filter.custom = customFilter;
    mySelf.setState({
      filter,
    });
    mySelf.updateFilterOptions(filter);
  };

  updateFilterOptions = filter => {
    this.props.dispatch({
      type: 'device/updateFilterOptions',
      payload: filter,
    });
  };

  getFilters = () => {
    let mySelf = this;
    let { filter } = mySelf.state;
    // console.log(filter);

    let {
      sort: sortFilter,
      group: groupFilter,
      deviceType: deviceTypeFilter,
      deviceStatus: deviceStatusFilter,
      custom: customFilter,
    } = filter;

    let filterFormat = {};
    filterFormat.sort = sortFilter.selected;

    if (Number(groupFilter.selected) !== -1) {
      filterFormat.group = groupFilter.selected;
    }

    if (Number(deviceTypeFilter.selected) !== -1) {
      filterFormat.deviceType = deviceTypeFilter.selected;
    }

    if (Number(deviceStatusFilter.selected) !== -1) {
      filterFormat.deviceStatus = deviceStatusFilter.selected;
    }

    if (customFilter.nat && customFilter.nat.length !== 0) {
      filterFormat.nat = customFilter.nat;
    }

    if (customFilter.isp && customFilter.isp.length !== 0) {
      filterFormat.isp = customFilter.isp;
    }

    if (customFilter.province && customFilter.province.length !== 0) {
      filterFormat.province = customFilter.province;
    }

    // console.log(filterFormat);

    return filterFormat;
  };

  reportFilter = () => {
    const { filter } = this.state;
    let reportData;
    const filterData = {
      rank: filter.sort.selected === '-1' ? '默认排序' : SORT_MAP[filter.sort.selected],
      group: filter.group.selected === '-1' ? '全部' : GROUP_MAP[filter.group.selected],
      device_type:
        filter.deviceType.selected === '-1' ? '全部' : DEVICE_TYPE_MAP[filter.deviceType.selected],
      status:
        filter.deviceStatus.selected === '-1'
          ? '全部'
          : DEVICE_STATUS_MAP[filter.deviceStatus.selected],
    };
    const custom = filter.custom;
    reportData = {
      ...filterData,
      nat: this.getFilterStr(NAT_TYPE_MAP, custom.nat),
      disk: '',
      isp: this.getFilterStr(ISP_MAP, custom.isp),
      prov: this.getFilterStr(PROVINCE_MAP, custom.province),
    };
    reportEvent('10019', reportData);
  };

  getFilterStr = (filterMap, filterArr) => {
    if (!filterArr.length) return '';
    const filterOptions = filterArr.map(item => {
      return filterMap[item];
    });
    return filterOptions.join(',');
  };

  render() {
    // const { income: { incomeList } } = this.props;
    let mySelf = this;
    let { options, filter } = mySelf.state;
    let {
      sort: sortOptions,
      group: groupOptions,
      deviceType: deviceTypeOptions,
      deviceStatus: deviceStatusOptions,
      nat: natOptions,
      // disk: diskOptions,
      isp: ispOptions,
      province: provinceOptions,
    } = options;
    let {
      sort: sortFilter,
      group: groupFilter,
      deviceType: deviceTypeFilter,
      deviceStatus: deviceStatusFilter,
      custom: customFilter,
    } = filter;
    let {
      nat: natFilter,
      // disk: diskFilter,
      isp: ispFilter,
      province: provinceFilter,
      selectedLength: customSelectedLength,
    } = customFilter;

    //设备状态
    let renderDeviceStatusOptions = () => {
      let dom = null;
      if (deviceStatusOptions && deviceStatusOptions.length > 0) {
        dom = deviceStatusOptions.map((item, index) => {
          let { key, label } = item;
          let tempDom = null;
          tempDom = (
            <li
              key={index}
              className={`${deviceStatusFilter.selected === key ? styles['on'] : ''}`}
              onClick={() => mySelf.changeFilter('deviceStatus', key)}
            >
              <em>{label}</em>
            </li>
          );
          return tempDom;
        });
      }
      return dom;
    };

    //排序
    let renderSortOptions = () => {
      let dom = null;
      if (sortOptions && sortOptions.length > 0) {
        dom = sortOptions.map((item, index) => {
          let { key, label } = item;
          let tempDom = null;
          tempDom = (
            <li
              key={index}
              className={`${sortFilter.selected === key ? styles['on'] : ''}`}
              onClick={() => mySelf.changeFilter('sort', key)}
            >
              {label}
            </li>
          );
          return tempDom;
        });
      }
      return dom;
    };

    //分组
    let renderGroupOptions = () => {
      let dom = null;
      if (groupOptions && groupOptions.length > 0) {
        dom = groupOptions.map((item, index) => {
          let { key, label, count } = item;
          let tempDom = null;
          tempDom = (
            <li
              key={index}
              className={`${Number(groupFilter.selected) === Number(key) ? styles['on'] : ''}`}
              onClick={() => mySelf.changeFilter('group', key)}
            >
              {label} {count !== undefined ? `(${count})` : ''}
            </li>
          );
          return tempDom;
        });
      }
      return dom;
    };

    //设备类型
    let renderDeviceTypeOptions = () => {
      let dom = null;
      if (deviceTypeOptions && deviceTypeOptions.length > 0) {
        dom = deviceTypeOptions.map((item, index) => {
          let { key, label } = item;
          let tempDom = null;
          tempDom = (
            <li
              key={index}
              className={`${deviceTypeFilter.selected === key ? styles['on'] : ''}`}
              onClick={() => mySelf.changeFilter('deviceType', key)}
            >
              {label}
            </li>
          );
          return tempDom;
        });
      }
      return dom;
    };

    //NAT类型
    let renderNatOptions = () => {
      let dom = null;
      if (natOptions && natOptions.length > 0) {
        dom = natOptions.map((item, index) => {
          let { key, label } = item;
          let tempDom = null;
          tempDom = (
            <li
              key={index}
              className={`${natFilter.includes(key) ? styles['on'] : ''}`}
              onClick={() => mySelf.changeCustomFilter('nat', key)}
            >
              <em>{label}</em>
              {natFilter.includes(key) ? <i></i> : null}
            </li>
          );
          return tempDom;
        });
      }
      return dom;
    };

    //磁盘
    /*let renderDiskOptions = () => {
      let dom = null;
      if (diskOptions && diskOptions.length > 0){
        dom = diskOptions.map((item,index) => {
          let { key, label } = item;
          let tempDom = null;
          tempDom = (
            <li 
              key={index} 
              className={`${diskFilter.includes(key)?styles["on"]:""}`}
              onClick={() => mySelf.changeCustomFilter("disk", key)}
            >
              <em>{ label }</em>
              { diskFilter.includes(key)?(<i></i>):null }
            </li>
          );
          return tempDom;
        });
      }
      return dom
    };*/

    //运营商
    let renderIspOptions = () => {
      let dom = null;
      if (ispOptions && ispOptions.length > 0) {
        dom = ispOptions.map((item, index) => {
          let { key, label } = item;
          let tempDom = null;
          tempDom = (
            <li
              key={index}
              className={`${ispFilter.includes(key) ? styles['on'] : ''}`}
              onClick={() => mySelf.changeCustomFilter('isp', key)}
            >
              <em>{label}</em>
              {ispFilter.includes(key) ? <i></i> : null}
            </li>
          );
          return tempDom;
        });
      }
      return dom;
    };

    //省份
    let renderProvinceOptions = () => {
      let dom = null;
      if (provinceOptions && provinceOptions.length > 0) {
        dom = provinceOptions.map((item, index) => {
          let { key, label } = item;
          let tempDom = null;
          tempDom = (
            <li
              key={index}
              className={`${provinceFilter.includes(key) ? styles['on'] : ''}`}
              onClick={() => mySelf.changeCustomFilter('province', key)}
            >
              <em>{label}</em>
              {provinceFilter.includes(key) ? <i></i> : null}
            </li>
          );
          return tempDom;
        });
      }
      return dom;
    };

    return (
      <div className={styles['hd-filter']}>
        <ul className={styles['hd-filter-list']}>
          <li
            className={`${styles['on']} ${sortFilter.show ? styles['arrow-up'] : ''}`}
            onClick={() => mySelf.clickFilter('sort')}
          >
            <span>{SORT_MAP[sortFilter.selected]}</span>
          </li>
          <li
            className={`${Number(groupFilter.selected) !== -1 ? styles['on'] : ''} ${
              groupFilter.show ? styles['arrow-up'] : ''
            }`}
            onClick={() => mySelf.clickFilter('group')}
          >
            <span>{GROUP_MAP[groupFilter.selected] || '分组'}</span>
          </li>
          <li
            className={`${Number(deviceTypeFilter.selected) !== -1 ? styles['on'] : ''} ${
              deviceTypeFilter.show ? styles['arrow-up'] : ''
            }`}
            onClick={() => mySelf.clickFilter('deviceType')}
          >
            <span>{DEVICE_TYPE_MAP[deviceTypeFilter.selected]}</span>
          </li>
          <li
            className={`${customSelectedLength > 0 ? styles['on'] : ''} ${
              customFilter.show ? styles['arrow-up'] : ''
            }`}
            onClick={() => mySelf.clickFilter('custom')}
          >
            筛选
            {customSelectedLength > 0 && <em>{customSelectedLength}</em>}
          </li>
        </ul>
        <ul className={styles['tablist']}>{renderDeviceStatusOptions()}</ul>

        {/*下拉-默认排列项*/}
        <div
          className={styles['pop-drop']}
          style={{ display: sortFilter.show ? 'block' : 'none' }}
          onClick={() => mySelf.showFilterModal('sort', false)}
        >
          <ul className={styles['pop-txtlist']} onClick={e => e.stopPropagation()}>
            {renderSortOptions()}
          </ul>
        </div>

        {/*下拉-分组*/}
        <div
          className={styles['pop-drop']}
          style={{ display: groupFilter.show ? 'block' : 'none' }}
          onClick={() => mySelf.showFilterModal('group', false)}
        >
          <ul className={styles['pop-txtlist']}>{renderGroupOptions()}</ul>
        </div>

        {/*下拉-类型*/}
        <div
          className={styles['pop-drop']}
          style={{ display: deviceTypeFilter.show ? 'block' : 'none' }}
          onClick={() => mySelf.showFilterModal('deviceType', false)}
        >
          <ul className={styles['pop-txtlist']} onClick={e => e.stopPropagation()}>
            {renderDeviceTypeOptions()}
          </ul>
        </div>

        {/*下拉-筛选*/}
        <div
          className={styles['pop-drop']}
          style={{ display: customFilter.show ? 'block' : 'none' }}
          onClick={() => mySelf.triggerCustomModal(false)}
        >
          <div className={styles['pop-filter']} onClick={e => e.stopPropagation()}>
            <div className={styles['pop-filter-scroll']}>
              <div className={styles['pop-filter-u']}>
                <h3>NAT类型</h3>
                <ul className={styles['tablist']}>{renderNatOptions()}</ul>
              </div>
              {/*<div className={styles["pop-filter-u"]}>
                <h3>硬盘空间</h3>
                <ul className={styles["tablist"]}>
                  { renderDiskOptions() }
                </ul>
              </div>*/}
              <div className={styles['pop-filter-u']}>
                <h3>运营商</h3>
                <ul className={styles['tablist']}>{renderIspOptions()}</ul>
              </div>
              <div className={styles['pop-filter-u']}>
                <h3>省份</h3>
                <ul className={styles['tablist']}>{renderProvinceOptions()}</ul>
              </div>
            </div>
            <div className={styles['pop-filter-btn']}>
              <ul>
                <li>
                  <button
                    className={`${styles['btn']} ${
                      customSelectedLength === 0 ? styles['btn-grey'] : ''
                    }`}
                    onClick={() => mySelf.clearCustomFilter()}
                  >
                    重置
                  </button>
                </li>
                <li>
                  <button className={styles['btn']} onClick={() => mySelf.completeCustomSelected()}>
                    完成
                    {customSelectedLength > 0 && `（已选${customSelectedLength}）`}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
